import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { notifications } from '@mantine/notifications';
import { clearPersistedCache } from '@/lib/queryPersistence';

export function useLogout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      clearPersistedCache();
      // Clear ICP-related session storage on logout
      sessionStorage.removeItem('icpDetailSelectedElements');
      sessionStorage.removeItem('icpDetailShowOutOfRangeOnly');
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      notifications.show({
        title: 'Logout Failed',
        message: 'Please try again',
        color: 'red',
      });
    }
  };

  return { handleLogout };
}
